/**
 * Solis Fortune — content guard.
 *
 * Discourages casual copying: blocks right-click, copy/cut, text selection,
 * image dragging and the usual keyboard shortcuts.
 *
 * Deliberate exemptions — these exist to protect conversion, not to weaken the
 * guard:
 *   - form fields (input, textarea, select, contenteditable) keep full
 *     selection, copy AND paste, so customers can still paste an email address,
 *     a delivery address or a discount code;
 *   - the `paste` event is never blocked anywhere;
 *   - the theme editor (Shopify.designMode) is skipped, so the guard does not
 *     fight you while you work on the store.
 *
 * This is a deterrent, not protection. Anyone can read the page via view-source,
 * with JavaScript disabled, or with curl, and server-side crawlers never run
 * this file at all.
 *
 * Turn off: Theme settings > Content protection > uncheck. No code change.
 */
(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) return;

  var config = window.SolisGuard || {};
  var EDITABLE = 'input, textarea, select, [contenteditable=""], [contenteditable="true"]';

  function isEditable(target) {
    if (!target) return false;
    var el = target.nodeType === 1 ? target : target.parentElement;
    return !!(el && el.closest && el.closest(EDITABLE));
  }

  function blockUnlessEditable(event) {
    if (isEditable(event.target)) return;
    event.preventDefault();
  }

  document.addEventListener('contextmenu', blockUnlessEditable);
  document.addEventListener('copy', blockUnlessEditable);
  document.addEventListener('cut', blockUnlessEditable);
  document.addEventListener('selectstart', blockUnlessEditable);

  document.addEventListener('dragstart', function (event) {
    var el = event.target;
    if (el && el.nodeType === 1 && el.tagName === 'IMG') event.preventDefault();
  });

  if (config.keys === false) return;

  // Ctrl/Cmd + C, X, A, U (view source), S (save), P (print).
  var BLOCKED_KEYS = ['c', 'x', 'a', 'u', 's', 'p'];

  document.addEventListener('keydown', function (event) {
    if (!(event.ctrlKey || event.metaKey)) return;
    if (isEditable(event.target)) return;
    if (BLOCKED_KEYS.indexOf(String(event.key).toLowerCase()) === -1) return;
    event.preventDefault();
  });
})();
